import styled from 'styled-components';
import { Button } from '../design-system';

const UnstyledButton = styled(Button)`
  font-size: 100%;
  font-family: inherit;
  border: 0;
  padding: 0;
  cursor: pointer;
`;

export default UnstyledButton;
